import './App.css';
import Portfolio from './Portfolio';
import {  Route, Routes } from 'react-router-dom';
import Perfil from './Perfil';
import PortfolioProvider from './context/PortfolioProvider';

function App() {
  return (
    <PortfolioProvider>
      <Routes>
        <Route path="/perfil" element={ <Perfil /> } />
        <Route exact path="/" element={ <Portfolio /> } />
      </Routes>
    </PortfolioProvider>
  );
}

export default App;
